/* global Detectizr */
import store from '../store/store';
import config from '../config'
import signals from '../store/signals';

function Scroll () {
    let scrollId

    function init () {
        scroll();
        window.addEventListener('scroll', scroll);
    }

    function remove () {
        window.removeEventListener('scroll', scroll);
    }

    function scroll (e) {
        store.scroll.set(window.scrollY)

        window.requestAnimationFrame(() => {
            clearTimeout(scrollId)
            scrollId = setTimeout(doneScroll, 100)
        });
    }

    function doneScroll () {
        signals.doneScroll.dispatch()
    }

  return {
    init,
    remove,
  };
}
export default Scroll();
